import LogoText from '../LogoText/LogoText';
import './StepHeader.scss';

interface StepHeaderProps {
  title: string;
  description: string | string[];
}
const StepHeader = ({ title, description }: StepHeaderProps) => {
  const descriptions = Array.isArray(description) ? description : [description];

  return (
    <>
      <LogoText />

      <h2 className="step-header-title">{title}</h2>

      <div className="step-header-description-container">
        {descriptions.map((desc, index) => (
          <h5 key={index} className="">
            {desc}
          </h5>
        ))}
      </div>
    </>
  );
};

export default StepHeader;
